import { useMemo, useRef, useState } from "react";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { StyledBackgroundImageCard } from "segments/desktop/grid/layouts/background-image-cards-grid/background-image-card/background-image-cards.scss";
import { generateCloudinaryImageUrl, generateCloudinaryVideoUrl } from "services/community/cloudinary-service";
import classnames from "classnames";
import CardButton from "./card-button/card-button";

const DEFAULT_PARAGRAPH = {
  topic: {}
};

const COLOUDINERY_FIRST_FRAME_FORMAT = "so_0";
const IMAGE_EXTENSION = "jpg";

const BackgroundImageCard = ({
  backgroundVideo,
  cardHeight,
  paragraph,
  fullParagraphAdvancedConfig,
  button,
  onHover,
  backgroundImage
}) => {
  const videoRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const videoUrl = useMemo(
    () => backgroundVideo && encodeURI(generateCloudinaryVideoUrl(backgroundVideo?.formats[0])),
    [backgroundVideo]
  );

  const firstFrameImage = useMemo(() => {
    if (!videoUrl) return null;

    const firstFrameFormat = videoUrl.replace(/\/upload\//, `/upload/${COLOUDINERY_FIRST_FRAME_FORMAT}/`);
    return firstFrameFormat.replace(/(\.[\w\d_-]+)$/i, `.${IMAGE_EXTENSION}`);
  }, [videoUrl]);

  const cardBackgroundImage = useMemo(
    () => firstFrameImage || encodeURI(generateCloudinaryImageUrl(backgroundImage)),
    [backgroundImage, firstFrameImage]
  );

  const onMouseEnter = () => {
    videoRef?.current?.play();
    setIsHovered(true);
    onHover?.();
  };

  const onMouseLeave = () => {
    if (videoRef?.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
    setIsHovered(false);
  };

  return (
    <StyledBackgroundImageCard
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={classnames("background-image-card", { active: videoUrl && isHovered })}
      cardHeight={cardHeight}
      backgroundImage={cardBackgroundImage}
    >
      {videoUrl && (
        <div className="background-video">
          <video ref={videoRef} loop muted>
            <source src={videoUrl} />
          </video>
        </div>
      )}
      <div className="paragraph-wrapper" style={{ marginTop: fullParagraphAdvancedConfig?.marginTop }}>
        <FullParagraph
          {...fullParagraphAdvancedConfig}
          {...DEFAULT_PARAGRAPH}
          {...paragraph}
          titleClassName="card-title"
        />
        {button?.buttonType && <CardButton {...button} />}
      </div>
      <div className="card-image" />
    </StyledBackgroundImageCard>
  );
};

export default BackgroundImageCard;
